import { characters } from "@/mocks/bookData";

export default function CastSection() {
  return (
    <section
      id="characters"
      className="w-full px-6 py-24 border-b border-[#111] scroll-mt-20"
    >
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="mb-14">
          <div className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.4em] uppercase mb-3">
            — &nbsp; Dramatis Personae
          </div>
          <h2 className="font-['Special_Elite'] text-white text-4xl md:text-5xl border-b border-[#1A1A1A] pb-6">
            Cast of Characters
          </h2>
        </div>

        {/* Characters */}
        <div className="flex flex-col gap-8">
          {characters.map((char) => (
            <div
              key={char.name}
              className="flex flex-col sm:flex-row gap-6 py-6 border-b border-[#111] last:border-b-0"
            >
              {/* Left: Name Block */}
              <div className="sm:w-52 flex-shrink-0">
                <div
                  className="font-['Special_Elite'] text-xl leading-tight mb-1"
                  style={{ color: char.color }}
                >
                  {char.name}
                </div>
                {char.alias && (
                  <div className="font-['Share_Tech_Mono'] text-[#444] text-xs tracking-[0.2em] uppercase">
                    &ldquo;{char.alias}&rdquo;
                  </div>
                )}
                <div
                  className="font-['Share_Tech_Mono'] text-xs tracking-[0.15em] uppercase mt-2 px-2 py-1 border inline-block"
                  style={{ color: char.color, borderColor: `${char.color}30`, backgroundColor: `${char.color}0D` }}
                >
                  {char.role}
                </div>
              </div>

              {/* Right: Description */}
              <div className="flex-1">
                <p className="font-['Rajdhani'] text-[#888] leading-[1.85] text-base">
                  {char.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
